import { useCallback, useRef } from "react";

/**
 * Guarda de "última requisição vence" (decisão U1). Chame `begin()` ao disparar a busca e use o
 * `isLatest()` devolvido antes de gravar o resultado: respostas antigas são ignoradas.
 */
export function useLatestRequest(): () => () => boolean {
  const seq = useRef(0);
  return useCallback(() => {
    seq.current += 1;
    const id = seq.current;
    return () => id === seq.current;
  }, []);
}
